<template>
  <GmapMarker
    v-if="warehouse.geo_lat && warehouse.geo_lon"
    :options="markerOptions"
    @click="!disabled && $emit('click', warehouse)"
  >
    <div class="relative">
      <img
        alt="marker-icon"
        :src="markerIcon.marker"
        style="width: 35px; height: 35px"
      >
      <div
        v-if="markerIcon.image"
        class="absolute left-1.5 top-2 bg-white rounded-full flex items-center justify-center"
        style=" width: 16px; height: 16px; left: calc(50% - 8px); top: 5px;"
      >
        <img
          v-if="markerIcon.image"
          :src="markerIcon.image"
          alt="wholesaler"
          class="object-contain"
          style="width: calc(100% - 5px); height: calc(100% - 5px);"
        >
      </div>
    </div>
  </GmapMarker>
</template>

<script setup lang="ts">
import {CustomMarker as GmapMarker} from "vue3-google-map";
import {computed} from "vue";
import {Warehouse} from "@/core/interfaces/warehouses";
import DistributorAvailabilityMapService from "@/disruption-logistics/services/DistributorAvailabilityMapService";

const {warehouse, isAvailable = null, members, disabled = false} = defineProps<{
    warehouse: Warehouse,
    isAvailable?: boolean | null,
    members?: any[],
    disabled?: boolean
}>();
defineEmits(["click"]);

/**
 * The marker options.
 */
const markerOptions = computed((): google.maps.CustomMarkerOptions => {
    return {
        position: {
            lat: warehouse.geo_lat || 0,
            lng: warehouse.geo_lon || 0
        },
        anchorPoint: 'BOTTOM_CENTER',
        zIndex: zIndex.value
    };
});

/**
 * The marker icon.
 */
const markerIcon = computed(() => {
    return {
        marker: DistributorAvailabilityMapService.getMarkerImage(isAvailable, members),
        image: DistributorAvailabilityMapService.getWholesalerImage(warehouse.wholesaler_id)
    };
});

/**
 * The marker zIndex.
 */
const zIndex = computed(() => {
    if (isAvailable === null) {
        return 1;
    }

    if (!isAvailable) {
        return 2;
    }

    if (isAvailable && !members?.length) {
        return 3;
    }

    return 4;
});

</script>
